







































































































import { Component, Prop, Vue } from 'vue-property-decorator'
/* module */
import DateClass from '@/app/module/date'
@Component
export default class WeatherContent extends Vue {
  @Prop() private weatherData!: any
  @Prop() private weatherErrorMsg!: string
  @Prop() private showWeatherErrorFlag!: boolean

  private displayValue (value: number|string) {
    return value !== null && value !== undefined ? value : '-'
  }

  private displayWeatherName (value: number|string) {
    return value !== null && value !== undefined ? value : '不明'
  }

  /* 天気アイコンの判定 */
  private judgmentWeatherIcon (code: any, date: any) {
    let hour!: number
    if (date !== '') {
      const dateTime = new Date(date)
      hour = Number(dateTime.getHours())
    }

    if (code < 100) { // 2桁天気コード
      // 19:00以上 or 06:00未満の場合夜用のアイコンを返却
      if ((hour >= 19 || hour < 6) && (code === 10 || code === 20 || code === 21 || code === 24)) {
        switch (code) {
          // 晴れ
          case 10:
            return require('@/assets/icon/weather_forecast/forecast_icon-moon_iphone.png')

          // 晴れときどき曇り
          case 20:
            return require('@/assets/icon/weather_forecast/forecast_icon-moon_cloud_iphone.png')

          // 晴れ時々くもり にわか雨の可能性あり
          case 21:
          case 24:
            return require('@/assets/icon/weather_forecast/forecast_icon-moon_cloud(rain)_iphone.png')
        }
      } else {
        switch (code) {
          // 晴れ
          case 10:
            return require('@/assets/icon/weather_forecast/forecast_icon-sun_iphone.png')

          // 晴れときどき曇り
          case 20:
            return require('@/assets/icon/weather_forecast/forecast_icon-sun_cloud_iphone.png')

          // 晴れ時々くもり にわか雨の可能性あり
          case 21:
          case 24:
            return require('@/assets/icon/weather_forecast/forecast_icon-sun_cloud(rain)_iphone.png')

          // くもり
          case 30:
          case 34:
            return require('@/assets/icon/weather_forecast/forecast_icon-cloud_iphone.png')

          // くもり 雨の可能性あり
          case 31:
            return require('@/assets/icon/weather_forecast/forecast_icon-cloud(rain)_iphone.png')

          // くもり時々雪
          case 33:
            return require('@/assets/icon/weather_forecast/forecast_icon-snow_cloud_iphone.png')

          // くもり時々雨
          case 41:
            return require('@/assets/icon/weather_forecast/forecast_icon-cloud_rain_iphone.png')

          // 雪か雨時々くもり
          case 42:
            return require('@/assets/icon/weather_forecast/forecast_icon-sleet_cloud_iphone.png')

          // 雪時々くもり
          case 43:
            return require('@/assets/icon/weather_forecast/forecast_icon-snow_cloud_iphone.png')

          // 雨
          case 51:
          case 54:
          case 61:
          case 64:
          case 71:
          case 74:
          case 81:
          case 84:
            return require('@/assets/icon/weather_forecast/forecast_icon-rain_iphone.png')

          // みぞれ（雪か雨）
          case 52:
          case 55:
            return require('@/assets/icon/weather_forecast/forecast_icon-sleet_iphone.png')

          // 雪
          case 53:
          case 56:
          case 63:
          case 66:
          case 73:
          case 76:
          case 83:
          case 86:
            return require('@/assets/icon/weather_forecast/forecast_icon-snow_iphone.png')

          // 不明
          default:
            return require('@/assets/icon/weather_unknown.svg')
        }
      }
    } else { // 3桁天気コード
      switch (code) {
        case 100:
          return require('@/assets/icon/weather_forecast/v2/sunny/100_sunny.png')
        case 101:
          return require('@/assets/icon/weather_forecast/v2/sunny/101_sunny_sometimes_cloudy.png')
        case 102:
          return require('@/assets/icon/weather_forecast/v2/sunny/102_sunny_temporary_rainy.png')
        case 103:
          return require('@/assets/icon/weather_forecast/v2/sunny/103_sunny_sometimes_rainy.png')
        case 104:
          return require('@/assets/icon/weather_forecast/v2/sunny/104_sunny_temporary_snow.png')
        case 105:
          return require('@/assets/icon/weather_forecast/v2/sunny/105_sunny_sometimes_snow.png')
        case 106:
          return require('@/assets/icon/weather_forecast/v2/sunny/106_sunny_temporary_sleet.png')
        case 107:
          return require('@/assets/icon/weather_forecast/v2/sunny/107_sunny_sometimes_sleet.png')
        case 108:
          return require('@/assets/icon/weather_forecast/v2/sunny/108_sunny_temporary_thunder.png')
        case 110:
          return require('@/assets/icon/weather_forecast/v2/sunny/110_sunny_after_sometimes_cloudy.png')
        case 111:
          return require('@/assets/icon/weather_forecast/v2/sunny/111_sunny_after_cloudy.png')
        case 112:
          return require('@/assets/icon/weather_forecast/v2/sunny/112_sunny_after_temporary_rainy.png')
        case 113:
          return require('@/assets/icon/weather_forecast/v2/sunny/113_sunny_after_sometimes_rainy.png')
        case 114:
          return require('@/assets/icon/weather_forecast/v2/sunny/114_sunny_after_rainy.png')
        case 115:
          return require('@/assets/icon/weather_forecast/v2/sunny/115_sunny_after_temporary_snow.png')
        case 116:
          return require('@/assets/icon/weather_forecast/v2/sunny/116_sunny_after_sometimes_snow.png')
        case 117:
          return require('@/assets/icon/weather_forecast/v2/sunny/117_sunny_after_snow.png')
        case 118:
          return require('@/assets/icon/weather_forecast/v2/sunny/118_sunny_after_sleet.png')
        case 119:
          return require('@/assets/icon/weather_forecast/v2/sunny/119_sunny_after_thunder.png')
        case 140:
          return require('@/assets/icon/weather_forecast/v2/sunny/140_sunny_sometimes_thunder.png')
        case 149:
          return require('@/assets/icon/weather_forecast/v2/sunny/117_sunny_after_snow.png')
        case 150:
          return require('@/assets/icon/weather_forecast/v2/sunny/105_sunny_sometimes_snow.png')
        case 156:
          return require('@/assets/icon/weather_forecast/v2/sunny/156_sunny_sometimes_cloudy.png')
        case 158:
          return require('@/assets/icon/weather_forecast/v2/sunny/101_sunny_sometimes_cloudy.png')
        case 160:
          return require('@/assets/icon/weather_forecast/v2/sunny/160_sunny_temporary_sleet.png')
        case 165:
          return require('@/assets/icon/weather_forecast/v2/sunny/165_sunny_after_sometimes_cloudy.png')
        case 166:
          return require('@/assets/icon/weather_forecast/v2/sunny/166_sunny_after_cloudy.png')
        case 168:
          return require('@/assets/icon/weather_forecast/v2/sunny/111_sunny_after_cloudy.png')
        case 170:
          return require('@/assets/icon/weather_forecast/v2/sunny/170_sunny_sometimes_sleet.png')
        case 181:
          return require('@/assets/icon/weather_forecast/v2/sunny/181_sunny_after_sleet.png')
        case 200:
          return require('@/assets/icon/weather_forecast/v2/cloudy/200_cloudy.png')
        case 201:
          return require('@/assets/icon/weather_forecast/v2/cloudy/201_cloudy_sometimes_sunny.png')
        case 202:
          return require('@/assets/icon/weather_forecast/v2/cloudy/202_cloudy_temporary_rainy.png')
        case 203:
          return require('@/assets/icon/weather_forecast/v2/cloudy/203_cloudy_sometimes_rainy.png')
        case 204:
          return require('@/assets/icon/weather_forecast/v2/cloudy/204_cloudy_temporary_snow.png')
        case 205:
          return require('@/assets/icon/weather_forecast/v2/cloudy/205_cloudy_sometimes_snow.png')
        case 206:
          return require('@/assets/icon/weather_forecast/v2/cloudy/206_cloudy_temporary_sleet.png')
        case 207:
          return require('@/assets/icon/weather_forecast/v2/cloudy/207_cloudy_sometimes_sleet.png')
        case 208:
          return require('@/assets/icon/weather_forecast/v2/cloudy/208_cloudy_temporary_thunder.png')
        case 210:
          return require('@/assets/icon/weather_forecast/v2/cloudy/210_cloudy_after_sometimes_sunny.png')
        case 211:
          return require('@/assets/icon/weather_forecast/v2/cloudy/211_cloudy_after_sunny.png')
        case 212:
          return require('@/assets/icon/weather_forecast/v2/cloudy/212_cloudy_after_temporary_rainy.png')
        case 213:
          return require('@/assets/icon/weather_forecast/v2/cloudy/213_cloudy_after_sometimes_rainy.png')
        case 214:
          return require('@/assets/icon/weather_forecast/v2/cloudy/214_cloudy_after_rainy.png')
        case 215:
          return require('@/assets/icon/weather_forecast/v2/cloudy/215_cloudy_after_temporary_snow.png')
        case 216:
          return require('@/assets/icon/weather_forecast/v2/cloudy/216_cloudy_after_sometimes_snow.png')
        case 217:
          return require('@/assets/icon/weather_forecast/v2/cloudy/217_cloudy_after_snow.png')
        case 218:
          return require('@/assets/icon/weather_forecast/v2/cloudy/218_cloudy_after_sleet.png')
        case 219:
          return require('@/assets/icon/weather_forecast/v2/cloudy/219_cloudy_after_thunder.png')
        case 240:
          return require('@/assets/icon/weather_forecast/v2/cloudy/240_cloudy_sometimes_thunder.png')
        case 249:
          return require('@/assets/icon/weather_forecast/v2/cloudy/217_cloudy_after_snow.png')
        case 250:
          return require('@/assets/icon/weather_forecast/v2/cloudy/250_cloudy_sometimes_snow.png')
        case 255:
          return require('@/assets/icon/weather_forecast/v2/cloudy/255_cloudy.png')
        case 256:
          return require('@/assets/icon/weather_forecast/v2/cloudy/256_cloudy_sometimes_sunny.png')
        case 257:
          return require('@/assets/icon/weather_forecast/v2/cloudy/200_cloudy.png')
        case 258:
          return require('@/assets/icon/weather_forecast/v2/cloudy/201_cloudy_sometimes_sunny.png')
        case 260:
          return require('@/assets/icon/weather_forecast/v2/cloudy/260_cloudy_temporary_sleet.png')
        case 265:
          return require('@/assets/icon/weather_forecast/v2/cloudy/265_cloudy_after_sometimes_sunny.png')
        case 266:
          return require('@/assets/icon/weather_forecast/v2/cloudy/266_cloudy_after_sunny.png')
        case 268:
          return require('@/assets/icon/weather_forecast/v2/cloudy/211_cloudy_after_sunny.png')
        case 270:
          return require('@/assets/icon/weather_forecast/v2/cloudy/270_cloudy_sometimes_sleet.png')
        case 281:
          return require('@/assets/icon/weather_forecast/v2/cloudy/281_cloudy_after_sleet.png')
        case 300:
          return require('@/assets/icon/weather_forecast/v2/rainy/300_rainy.png')
        case 301:
          return require('@/assets/icon/weather_forecast/v2/rainy/301_rainy_sometimes_sunny.png')
        case 302:
          return require('@/assets/icon/weather_forecast/v2/rainy/302_rainy_sometimes_cloudy.png')
        case 303:
          return require('@/assets/icon/weather_forecast/v2/rainy/303_rainy_sometimes_snow.png')
        case 304:
          return require('@/assets/icon/weather_forecast/v2/rainy/304_sleet.png')
        case 306:
          return require('@/assets/icon/weather_forecast/v2/rainy/306_heavy_rainy.png')
        case 307:
          return require('@/assets/icon/weather_forecast/v2/rainy/307_heavy_rainy.png')
        case 308:
          return require('@/assets/icon/weather_forecast/v2/rainy/308_heavy_rainy.png')
        case 309:
          return require('@/assets/icon/weather_forecast/v2/rainy/309_rainy_temporary_snow.png')
        case 311:
          return require('@/assets/icon/weather_forecast/v2/rainy/311_rainy_after_sunny.png')
        case 313:
          return require('@/assets/icon/weather_forecast/v2/rainy/313_rainy_after_cloudy.png')
        case 314:
          return require('@/assets/icon/weather_forecast/v2/rainy/314_rainy_after_sometimes_snow.png')
        case 315:
          return require('@/assets/icon/weather_forecast/v2/rainy/315_rainy_after_snow.png')
        case 316:
          return require('@/assets/icon/weather_forecast/v2/rainy/316_sleet_after_sunny.png')
        case 317:
          return require('@/assets/icon/weather_forecast/v2/rainy/317_sleet_after_cloudy.png')
        case 340:
          return require('@/assets/icon/weather_forecast/v2/rainy/340_sleet.png')
        case 341:
          return require('@/assets/icon/weather_forecast/v2/rainy/311_rainy_after_sunny.png')
        case 343:
          return require('@/assets/icon/weather_forecast/v2/rainy/313_rainy_after_cloudy.png')
        case 350:
          return require('@/assets/icon/weather_forecast/v2/rainy/350_thunder.png')
        case 361:
          return require('@/assets/icon/weather_forecast/v2/rainy/361_sleet_after_sunny.png')
        case 371:
          return require('@/assets/icon/weather_forecast/v2/rainy/371_sleet_after_cloudy.png')
        case 373:
          return require('@/assets/icon/weather_forecast/v2/rainy/340_sleet.png')
        case 400:
          return require('@/assets/icon/weather_forecast/v2/snow/400_snow.png')
        case 401:
          return require('@/assets/icon/weather_forecast/v2/snow/401_snow_sometimes_sunny.png')
        case 402:
          return require('@/assets/icon/weather_forecast/v2/snow/402_snow_sometimes_cloudy.png')
        case 403:
          return require('@/assets/icon/weather_forecast/v2/snow/403_snow_sometimes_rainy.png')
        case 405:
          return require('@/assets/icon/weather_forecast/v2/snow/405_heavy_snow.png')
        case 406:
          return require('@/assets/icon/weather_forecast/v2/snow/406_heavy_snow.png')
        case 407:
          return require('@/assets/icon/weather_forecast/v2/snow/407_heavy_snow.png')
        case 409:
          return require('@/assets/icon/weather_forecast/v2/snow/409_snow_temporary_rainy.png')
        case 411:
          return require('@/assets/icon/weather_forecast/v2/snow/411_snow_after_sunny.png')
        case 413:
          return require('@/assets/icon/weather_forecast/v2/snow/413_snow_after_cloudy.png')
        case 414:
          return require('@/assets/icon/weather_forecast/v2/snow/414_snow_after_rainy.png')
        case 441:
          return require('@/assets/icon/weather_forecast/v2/snow/411_snow_after_sunny.png')
        case 443:
          return require('@/assets/icon/weather_forecast/v2/snow/413_snow_after_cloudy.png')
        case 444:
          return require('@/assets/icon/weather_forecast/v2/snow/414_snow_after_rainy.png')
        case 450:
          return require('@/assets/icon/weather_forecast/v2/snow/450_thunder_snow.png')
        case 500:
          return require('@/assets/icon/weather_forecast/v2/rainy/300_rainy.png')
        case 550:
          return require('@/assets/icon/weather_forecast/v2/rainy/300_rainy.png')
        case 600:
          return require('@/assets/icon/weather_forecast/v2/snow/400_snow.png')
        case 650:
          return require('@/assets/icon/weather_forecast/v2/snow/400_snow.png')
        case 700:
          return require('@/assets/icon/weather_forecast/v2/rainy/308_heavy_rainy.png')
        case 750:
          return require('@/assets/icon/weather_forecast/v2/rainy/308_heavy_rainy.png')
        case 800:
          return require('@/assets/icon/weather_forecast/v2/snow/406_heavy_snow.png')
        case 850:
          return require('@/assets/icon/weather_forecast/v2/snow/406_heavy_snow.png')
        default: // 不明
          return require('@/assets/icon/weather_unknown.svg')
      }
    }
  }

  private getWeatherDataDay (index: number) {
    if (!this.weatherData || this.weatherData.length !== 10) {
      return 1
    }
    const weather: any = this.weatherData[index]
    if (weather.date_time === '') {
      return 1
    }
    return new Date(weather.date_time.replace(/-/g, '/')).getDay()
  }

  private displayDate (date: any, index: number) {
    let formingDate: string
    if (date !== '') {
      const dateTime = new Date(date.replace(/-/g, '/'))
      const day = ['日', '月', '火', '水', '木', '金', '土'][dateTime.getDay()]
      formingDate = DateClass.toDoubleDigits(dateTime.getDate()) + '\n(' + day + ')'
    } else {
      formingDate = '-\n　'
    }
    return formingDate
  }

  private displayTime (date: any) {
    let formingTime: string
    if (date !== '') {
      const dateTime = new Date(date.replace(/-/g, '/'))
      formingTime = DateClass.toDoubleDigits(dateTime.getHours()) + ':' + DateClass.toDoubleDigits(dateTime.getMinutes())
    } else {
      formingTime = '-'
    }
    return formingTime
  }
}
